import { DriverStatus, PosTerminalStatus, TransactionType } from 'enums';
import BooksOfAccounts from 'enums/books-of-accounts';
import ProductType from 'enums/product-type';
import Route from 'enums/route';
import UserRole from 'enums/user-role';
import locale from 'localization';

export const prettifyDriverStatus = (driverStatus) => {
  return (
    {
      [DriverStatus.Active]: locale.active,
      [DriverStatus.Inactive]: locale.inactive
    }[driverStatus] || ''
  );
};

export const prettifyVehicleStatus = (vehicleStatus) => {
  return (
    {
      [DriverStatus.Active]: locale.active,
      [DriverStatus.Inactive]: locale.inactive
    }[vehicleStatus] || ''
  );
};

export const prettifyPosTerminalStatus = (status) => {
  return (
    {
      [PosTerminalStatus.Available]: 'Available',
      [PosTerminalStatus.InUse]: 'In-used',
      [PosTerminalStatus.Inactive]: locale.inactive
    }[status] || ''
  );
};

export const prettifyProductType = (type) => {
  return (
    {
      [ProductType.Savings]: 'Savings',
      [ProductType.FixedDeposit]: 'Fixed Deposit',
      [ProductType.SharedCapital]: 'Shared Capital'
    }[type] || ''
  );
};

export const prettifyUserRole = (role) => {
  return (
    {
      [UserRole.Admin]: 'Admin',
      [UserRole.Conductor]: 'Conductor',
      [UserRole.Staff]: 'Staff',
      [UserRole.Inspector]: 'Inspector',
      [UserRole.Dispatcher]: 'Dispatcher'
    }[role] || ''
  );
};

export const prettifyTransactionType = (type) => {
  return (
    {
      [TransactionType.Regular]: 'Regular',
      [TransactionType.Member]: 'Member',
      [TransactionType.SeniorCitizen]: 'SC/S/PWD'
    }[type] || ''
  );
};

export const prettifyRoute = (route) => {
  return (
    {
      [Route.Lucban_Lucena]: 'Lucban - Lucena',
      [Route.Lucena_Lucban]: 'Lucena - Lucban',
      [Route.Tayabas_Mauban]: 'Tayabas - Mauban',
      [Route.Mauban_Tayabas]: 'Mauban - Tayabas'
    }[route] || ''
  );
};

export const prettifyBooksOfAccounts = (value) => {
  return (
    {
      [BooksOfAccounts.CashDisbursement]: 'Cash Disbursement Book',
      [BooksOfAccounts.CashReceipt]: 'Cash Receipt Book',
      [BooksOfAccounts.GeneralEntriesBook]: 'General Entries Book',
      [BooksOfAccounts.GeneralJournal]: 'General Journal',
      [BooksOfAccounts.GeneralLedger]: 'General Ledger'
    }[value] || ''
  );
};
